// Data-testid registry for AXIS FPS UI
export const INTRO = {
    root: "intro-sequence",
    axisWordmark: "intro-axis-wordmark",
    companyLogo: "intro-company-logo",
    gameTitle: "intro-game-title",
    skip: "intro-skip",
};

export const MENU = {
    root: "main-menu",
    beta: "beta-tag",
    play: "menu-play-button",
    profile: "menu-profile",
    inventory: "menu-inventory",
    settings: "menu-settings",
    career: "menu-career",
    store: "menu-store",
    news: "menu-news",
    friends: "menu-friends",
    statistics: "menu-statistics",
    exit: "menu-exit",
};

export const PLAY = {
    root: "play-menu",
    modeRanked: "mode-ranked",
    modeTraining: "mode-training",
    mapPrefix: "map-", // + slug
    teamPrefix: "team-",
    difficultyPrefix: "difficulty-",
    startMatch: "start-match",
    back: "play-back",
    lockedDialog: "ranked-locked-dialog",
    lockedDialogClose: "ranked-locked-dialog-close",
    // New Play Hub / flow testids
    hub: "play-hub",
    categoryCombat: "play-cat-combat",
    categoryPractice: "play-cat-practice",
    categoryServers: "play-cat-servers",
    // Combat sub-hub
    combatRanked: "combat-ranked",
    combatOpen: "combat-open",
    // Rule pickers (both Combat and Practice)
    ruleRound: "rule-round",
    ruleRapid: "rule-rapid",
    ruleSoloDrill: "rule-solodrill",
    // Team size picker prefix stays the same via teamPrefix
    // Review + deploy
    review: "play-review",
    reviewBtn: "play-review-btn",
    deploy: "play-deploy",
    savePreset: "play-save-preset",
    // Servers
    serversBrowse: "servers-browse",
    serversCreate: "servers-create",
    serverIdField: "server-id-field",
    serverIdRegenerate: "server-id-regenerate",
    serverIdCopy: "server-id-copy",
    serverCreateSubmit: "server-create-submit",
    // Weather / TOD / Bots
    weatherPrefix: "weather-",
    todPrefix: "tod-",
    friendlyDiffPrefix: "friendly-diff-",
    enemyDiffPrefix: "enemy-diff-",
    // Beta unavailable dialog
    betaUnavailable: "beta-unavailable-dialog",
    betaUnavailableClose: "beta-unavailable-close",
    betaUnavailableGoPractice: "beta-unavailable-goto-practice",
};

export const SETTINGS = {
    root: "settings-screen",
    tabPrefix: "settings-tab-",
    close: "settings-close",
    save: "settings-save",
    fov: "settings-fov",
    sensitivity: "settings-sensitivity",
    masterVolume: "settings-master-volume",
    quality: "settings-quality",
};

export const PROFILE = {
    root: "profile-screen",
    name: "profile-name",
    save: "profile-save",
    close: "profile-close",
    stats: "profile-stats",
};

export const HUD = {
    root: "match-hud",
    health: "hud-health",
    armor: "hud-armor",
    ammo: "hud-ammo",
    timer: "hud-timer",
    scoreYou: "hud-score-you",
    scoreEnemy: "hud-score-enemy",
    fps: "hud-fps",
    pauseToggle: "hud-pause",
};

export const MATCH = {
    root: "match-screen",
    pauseMenu: "pause-menu",
    resume: "pause-resume",
    quit: "pause-quit",
    endScreen: "match-end-screen",
    endTitle: "match-end-title",
    returnMenu: "match-return-menu",
};

export const PANEL = {
    close: "panel-close",
};
